// Product-card quick-add wiring.
//
// All the cart plumbing (AJAX, badge animation, button state cycle) lives in
// assets/cart-actions.js (window.toyCart). This file just intercepts the
// single-variant quick-add form submit.
//
// A single delegated listener on the document handles cards that exist at
// load AND cards injected later — the cart upsell rail and PDP
// recommendations swap their grids in asynchronously. The idempotency guard
// keeps it to one listener even if several sections include this script.
//
// If window.toyCart is missing, we let the form submit natively (it posts to
// /cart/add and navigates to /cart) — graceful degradation.

(function () {
  if (window.__toyCardWired) return;
  window.__toyCardWired = true;

  document.addEventListener('submit', (event) => {
    const form = event.target.closest('[data-card-add-to-cart]');
    if (!form) return;
    if (!window.toyCart) return; // native submit fallback

    event.preventDefault();
    const button = form.querySelector('button[type="submit"]');
    if (!button) return;
    window.toyCart.performAdd(button, () => new FormData(form));
  });
})();
